/*
 * WakeUp | PostHog checkout identity bridge - 1.1.0 auto preview/production
 * Separate storefront helper. NOT pixel code.
 * Environment is read from the current theme role; requires explicit analytics consent.
 * No network requests, URL decoration, form changes, or consent writes.
 */
(function wakeupPostHogIdentityBridge() {
  'use strict';
  const CONFIG = Object.freeze({
    ENABLED: true,
    PROJECT_ID: 313186,
    PUBLIC_PROJECT_TOKEN: 'phc_pmQgtcAf3DXbZYKHNH8zaDZRToXo5KbPrMADVixiLxzH',
    MAX_AGE_MS: 30 * 60 * 1000
  });
  if (!CONFIG.ENABLED) return;
  const KEY = 'wub_ph_checkout_context_v1';
  const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (!['wakeupbedding.com', 'www.wakeupbedding.com'].includes(window.location.hostname)) return;
  const shopify = window.Shopify;
  const theme = shopify && shopify.theme;
  if (!theme || shopify.designMode) return;
  const role = String(theme.role || '').toLowerCase();
  if (role !== 'unpublished' && role !== 'main') { removeOwn(); return; }
  const themeId = String(theme.id || '');
  if (!/^[1-9][0-9]{4,19}$/.test(themeId)) { removeOwn(); return; }
  const environment = role === 'main' ? 'production' : 'preview';

  function removeOwn() {
    try { window.sessionStorage.removeItem(KEY); } catch (_) {}
  }

  function permitted() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || privacy.analyticsProcessingAllowed() !== true || privacy.currentVisitorConsent().analytics !== 'yes') return false;
      if (window.navigator.doNotTrack === '1' || window.navigator.globalPrivacyControl === true) return false;
      const status = window.WUBPH && window.WUBPH.status && window.WUBPH.status();
      if (!status || status.enabled !== true || status.consent !== true) return false;
      if (!window.WUBPHSettings || window.WUBPHSettings.projectKey !== CONFIG.PUBLIC_PROJECT_TOKEN) return false;
      const sdk = window.posthog;
      return !!sdk && typeof sdk.get_distinct_id === 'function' &&
        typeof sdk.has_opted_out_capturing === 'function' && sdk.has_opted_out_capturing() === false;
    } catch (_) { return false; }
  }

  function sync() {
    try {
      if (!permitted()) { removeOwn(); return; }
      const sdk = window.posthog;
      const distinctId = sdk.get_distinct_id();
      // Never use an email address, customer ID, or arbitrary identified value.
      if (!UUID_RE.test(distinctId || '')) { removeOwn(); return; }
      const now = Date.now();
      let consentAt = now;
      try {
        const previous = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
        if (previous && previous.distinct_id === distinctId && previous.project_id === CONFIG.PROJECT_ID &&
            previous.environment === environment && previous.theme_id === themeId &&
            Number.isFinite(previous.consent_at) && previous.consent_at <= now && previous.consent_at >= 0 &&
            previous.expires_at > now) consentAt = previous.consent_at;
      } catch (_) {}
      let sessionId = null;
      try {
        const value = typeof sdk.get_session_id === 'function' ? sdk.get_session_id() : null;
        if (UUID_RE.test(value || '')) sessionId = value;
      } catch (_) {}
      const context = {
        v: 1,
        project_id: CONFIG.PROJECT_ID,
        theme_id: themeId,
        environment: environment,
        distinct_id: distinctId,
        session_id: sessionId,
        consent_at: consentAt,
        issued_at: now,
        expires_at: now + CONFIG.MAX_AGE_MS
      };
      // Only our own key. No SDK reconfiguration or identification calls.
      window.sessionStorage.setItem(KEY, JSON.stringify(context));
    } catch (_) { removeOwn(); }
  }

  document.addEventListener('wub:posthog-ready', sync);
  document.addEventListener('wub:checkout-click', sync);
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  window.addEventListener('pagehide', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();